// methods for encodeing/decodeing the data
const lookup = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
const reverseLookup = new Uint8Array(256);
for (let i = 0; i < lookup.length; i++) {
  reverseLookup[lookup.charCodeAt(i)] = i;
}

export function decodeBase64(base64String: string): ArrayBuffer {
  const base64StringLength = base64String.length;

  const placeHolderLength =
    base64String.charAt(base64StringLength - 2) === '='
      ? 2
      : base64String.charAt(base64StringLength - 1) === '='
        ? 1
        : 0;
  const bufferLength = (base64StringLength * 3) / 4 - placeHolderLength;

  const arrayBuffer = new ArrayBuffer(bufferLength);
  const uint8Array = new Uint8Array(arrayBuffer);

  let j = 0;
  for (let i = 0; i < base64StringLength; i += 4) {
    const tmp0 = reverseLookup[base64String.charCodeAt(i)];
    const tmp1 = reverseLookup[base64String.charCodeAt(i + 1)];
    const tmp2 = reverseLookup[base64String.charCodeAt(i + 2)];
    const tmp3 = reverseLookup[base64String.charCodeAt(i + 3)];

    uint8Array[j++] = (tmp0 << 2) | (tmp1 >> 4);
    uint8Array[j++] = ((tmp1 & 15) << 4) | (tmp2 >> 2);
    uint8Array[j++] = ((tmp2 & 3) << 6) | (tmp3 & 63);
  }

  return arrayBuffer;
}

export function encodeBase64(arrayBuffer: ArrayBuffer): string {
  const uint8Array = new Uint8Array(arrayBuffer);
  const length = uint8Array.length;
  let result = '';

  for (let i = 0; i < length; i += 3) {
    result += lookup[uint8Array[i] >> 2];
    result += lookup[((uint8Array[i] & 3) << 4) | (uint8Array[i + 1] >> 4)];
    result += lookup[((uint8Array[i + 1] & 15) << 2) | (uint8Array[i + 2] >> 6)];
    result += lookup[uint8Array[i + 2] & 63];
  }

  switch (length % 3) {
    case 1:
      result = result.substring(0, result.length - 2);
      break;
    case 2:
      result = result.substring(0, result.length - 1);
      break;
  }
  return result;
}

export function decodeBase64ToObj(base64String: string): unknown {
  const decodedBuffer = decodeBase64(base64String);
  const decodedString = new TextDecoder().decode(decodedBuffer);
  return JSON.parse(decodedString);
}

type PublicKeyCredentialRequestOptionsJson = Omit<
  PublicKeyCredentialRequestOptions,
  'challenge'
> & { challenge: string };

export async function fetchAssertionOptions(): Promise<PublicKeyCredentialRequestOptions> {
  const response = await fetch('login/assertion/options');
  const json = (await response.json()) as PublicKeyCredentialRequestOptionsJson;
  const options = json as unknown as PublicKeyCredentialRequestOptions;
  options.challenge = decodeBase64(json.challenge);
  return options;
}

type PublicKeyCredentialCreationOptionsJson = Omit<
  PublicKeyCredentialCreationOptions,
  'challenge'
> & { challenge: string };

export async function fetchAttestationOptions(): Promise<PublicKeyCredentialCreationOptions> {
  const response = await fetch('login/attestation/options');
  const json = (await response.json()) as PublicKeyCredentialCreationOptionsJson;
  // convert some string to ArrayBuffer
  const options = json as unknown as PublicKeyCredentialCreationOptions;
  options.challenge = decodeBase64(json.challenge);
  return options;
}
